import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import {
  DeleteSuccessStockArticlePayload,
  FetchSuccessStockArticleEventsPayload,
  FetchSuccessStockArticleItemsPayload,
  FetchSuccessStockArticlePayload,
  StockArticle,
  StockArticleAction,
  StockArticleActions
} from '../model/customer-article';
import { ResponsePayload } from '../model/request';

import createReducer from './createReducer';

export const customerArticles = createReducer<CustomerState<StockArticle[]>>({}, {
  [StockArticleActions.FETCH_CUSTOMER_ARTICLES_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber((
      action.payload as ResponsePayload<FetchSuccessStockArticlePayload>
    ).data, state, []);
  },
  [StockArticleActions.FETCH_CUSTOMER_ARTICLE_EVENTS_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber((oldState) => {
      const payload = action.payload as ResponsePayload<FetchSuccessStockArticleEventsPayload>;
      const articleId = payload.config.url.replace(/.*\/(\d+)\/events/, '$1');
      const articleIndex = oldState.findIndex(s => s.id === +articleId);

      if (articleIndex < 0) {
        return oldState;
      }

      return [
        ...oldState?.slice(0, articleIndex),
        {
          ...oldState[articleIndex],
          events: payload.data,
        },
        ...oldState.slice(articleIndex + 1)
      ]
    }, state, []);
  },
  [StockArticleActions.FETCH_CUSTOMER_ARTICLE_ITEMS_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber((oldState) => {
      const payload = action.payload as ResponsePayload<FetchSuccessStockArticleItemsPayload>;
      const articleId = payload.config.url.replace(/.*\/(\d+)\/items/, '$1');
      const articleIndex = oldState.findIndex(s => s.id === +articleId);

      if (articleIndex < 0) {
        return oldState;
      }

      return [
        ...oldState?.slice(0, articleIndex),
        {
          ...oldState[articleIndex],
          stockItems: payload.data,
        },
        ...oldState.slice(articleIndex + 1)
      ]
    }, state, []);
  },
  [StockArticleActions.UPDATE_CUSTOMER_ARTICLE_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber((oldState) => {
      const { data } = action.payload as ResponsePayload<StockArticle>;
      const articleIndex = oldState.findIndex(s => s.id === data.id);

      if (articleIndex < 0) {
        return oldState;
      }

      return [
        ...oldState.slice(0, articleIndex),
        {
          ...oldState[articleIndex],
          ...data,
        },
        ...oldState.slice(articleIndex + 1)
      ]
    }, state, []);
  },
  [StockArticleActions.CREATE_CUSTOMER_ARTICLE_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber(oldState => ([
      (action.payload as ResponsePayload<StockArticle>).data,
      ...(oldState || [])
    ]), state, []);
  },
  [StockArticleActions.DELETE_CUSTOMER_ARTICLE_SUCCESS](
    state: CustomerState<StockArticle[]>,
    action: StockArticleAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const articleId = (action.payload as ResponsePayload<DeleteSuccessStockArticlePayload>).data.id;
      const articleIndex = oldState.findIndex(s => s.id === +articleId);

      return [
        ...oldState.slice(0, articleIndex),
        ...oldState.slice(articleIndex + 1)
      ]
    }, state, []);
  },
});
